<template>
  <PDropdown placement="left-start" :offset="22" teleport="#modals-holder" :same-width="false">
    <template #activator="{ toggle }">
      <button
        data-sentry-id="UseASavedFluxBtn"
        @click="toggle"
        :disabled="!canInvokeFlux"
        :class="{
          'text-grey-425 cursor-not-allowed': !canInvokeFlux,
        }"
      >
        Utiliser un flux enregistré
      </button>
    </template>
    <template #default="{ close: closeSubMenu }">
      <div class="flex flex-col py-1 px-1 gap-1v w-full max-w-[16rem]">
        <div v-for="savedFlux in savedFluxItems" :key="savedFlux.id" class="flex items-center w-full">
          <button
            data-sentry-id="UseSavedFluxBtn-{{ savedFlux.id }}"
            @click="onApply(savedFlux.id, closeSubMenu)"
            class="whitespace-nowrap hover:bg-grey-1000-hover px-1v flex w-full text-ellipsis overflow-hidden"
          >
            <span class="w-full text-ellipsis overflow-hidden text-left">
              {{ savedFlux.name }}
            </span>
            <span>({{ savedFlux.flux.length }})</span>
          </button>
          <button
            data-sentry-id="DeleteSavedFluxBtn-{{ savedFlux.id }}"
            class="px-1v hover:bg-grey-1000-hover"
            @click="deleteSavedFlux(savedFlux.id, closeSubMenu)"
          >
            <OhVueIcon :name="deleteIcon" scale="0.8" />
          </button>
        </div>
      </div>
    </template>
  </PDropdown>
</template>

<script setup lang="ts">
import { PDropdown, useIcons } from "@pasta/box-v2";
import { RiDeleteBin6Line } from "oh-vue-icons/icons/ri";
import { type SavedFluxDto } from "../../../dto/saved-flux.dto";
import { computed } from "vue";
import { useNotifyAsyncOperation } from "../../../composable/useAsyncOperation";
import { useLetterFileSavedFluxStore } from "../../../stores/letter-file-saved-flux.store";
import { OhVueIcon } from "oh-vue-icons";
import { FormOperation } from "../../../types";

interface Props {
  savedFluxItems: SavedFluxDto[];
}
const props = defineProps<Props>();
const emit = defineEmits<{ (e: "apply", value: number): void }>();
const [deleteIcon] = useIcons(RiDeleteBin6Line);

const letterFileSavedFluxStore = useLetterFileSavedFluxStore();
const notifyAsyncOperation = useNotifyAsyncOperation();
const canInvokeFlux = computed(() => props.savedFluxItems.length >= 1);

async function fetchSavedFlux() {
  await letterFileSavedFluxStore.getMines();
}

async function deleteSavedFlux(id: number, close: () => void) {
  await notifyAsyncOperation(async () => {
    await letterFileSavedFluxStore.delete(id);
    await fetchSavedFlux();
    close();
  }, FormOperation.SAVED_FLUX);
}

async function onApply(id: number, close: () => void) {
  emit("apply", id);
  close();
}
</script>
